import React, { useState, useContext } from 'react';
import { ReactDatePicker } from '@mummssoftware/common-ui';
import { formatters } from '@mummssoftware/utils';
import { ReportContext } from '../Context/ReportContext';
import { SET_API_PARAM } from '../Context/constants';
export const DateParam = ({
  param
}) => {
  const [paramDate, setParamDate] = useState(param.defaultValue ? new Date(param.defaultValue) : new Date());
  const {
    dispatch
  } = useContext(ReportContext);

  const handleDateChange = date => {
    setParamDate(date);
    dispatch({
      type: SET_API_PARAM,
      payload: {
        id: param.id,
        value: formatters.YYYYMMDDtoMMDDYY(date.toISOString())
      }
    });
  };

  return /*#__PURE__*/React.createElement(ReactDatePicker, {
    selectedDate: paramDate,
    onChange: handleDateChange
  });
};